export const administrationPageEn = {
  menu: {
    users: 'User management',
    organizations: 'Organizations',
    offers: 'Offer overview',
    dashboard: 'Dashboard'
  }
};

export const administrationDashboardPageEn = {
  iframeTitle: 'Grafana operator dashboard',
  openInNewTab: 'Open in new tab',
  unconfigured:
    'The dashboard is not configured for this instance. Set VITE_GRAFANA_DASHBOARD_URL at deployment time.'
};

export const administrationUsersPageEn = {
  users: 'User management',
  search: 'Search',
  searchPlaceholder: 'Name or email',
  loading: 'Refreshing…',
  neverLoggedIn: 'Never logged in',
  noOrganizations: '—',
  openUserOffers: 'Show offers by {{name}} in the offer overview',
  openOrganization: 'Show organization {{name}} in organization management',
  pageSize: 'Entries per page',
  roleFilter: {
    label: 'Role',
    all: 'All',
    platformAdministrator: 'Administrator'
  },
  columns: {
    name: 'Name',
    email: 'Email address',
    accountType: 'Account type',
    organizations: 'Organizations',
    status: 'Active',
    administrator: 'Role',
    lastLogin: 'Last login',
    actions: 'Actions'
  },
  accountType: {
    private: 'Private',
    business: 'Business'
  },
  status: {
    active: 'Active',
    disabled: 'Disabled'
  },
  administrator: {
    yes: 'Administrator',
    no: 'User'
  },
  actions: {
    label: 'Actions',
    enable: 'Enable account',
    disable: 'Disable account',
    grantAdmin: 'Make administrator',
    revokeAdmin: 'Remove administrator role'
  },
  disableConfirmation: {
    title: 'Disable account?',
    content:
      'Do you really want to disable the account of {{name}}? The user will no longer be able to sign in.',
    confirm: 'Disable account',
    cancel: 'Cancel'
  },
  empty: {
    top: 'No users found',
    bottom: 'Adjust your search or try again later.'
  },
  toasts: {
    enabledUpdated: 'Account status updated',
    roleUpdated: 'Administrator role updated',
    actionFailed: 'Action failed'
  }
};

export const administrationOrganizationsPageEn = {
  search: 'Search',
  searchPlaceholder: 'Name, email or address',
  pageSize: 'Items per page',
  emptyValue: '—',
  openMemberUser: 'Show member {{email}} in user management',
  openOrganizationOffers:
    'Show offers for organization {{name}} in the offer overview ({{count}})',
  columns: {
    name: 'Name',
    email: 'Email',
    address: 'Address',
    members: 'Members',
    offers: 'Offers'
  },
  empty: {
    top: 'No organizations found',
    bottom: 'Adjust your search or check again later.'
  }
};

export const administrationOffersPageEn = {
  search: 'Search',
  searchPlaceholder: 'Offer name, organization or provider',
  pageSize: 'Entries per page',
  untitledOffer: 'Untitled',
  emptyValue: '—',
  missingOrganizationBadge: 'Organization missing',
  missingOrganizationBadgeTitle:
    'No valid organization is linked to this commercial offer.',
  emailProvider: 'Send email to {{email}}',
  openProviderUser: 'Show user {{email}} in user administration',
  openOrganization: 'Show organization {{name}} in organization management',
  typeFilter: {
    label: 'Type',
    all: 'All',
    ROOM: 'Rooms',
    MATERIAL: 'Items'
  },
  statusFilter: {
    label: 'Status',
    all: 'All',
    draft: 'Draft',
    published: 'Published'
  },
  availabilityFilter: {
    label: 'State',
    active: 'Active',
    suspended: 'Suspended',
    removed: 'Removed',
    all: 'All'
  },
  sort: {
    label: 'Sort by',
    'name-asc': 'Offer title: A–Z',
    'name-desc': 'Offer title: Z–A',
    'publishedAt-desc': 'Published on: Newest first',
    'publishedAt-asc': 'Published on: Oldest first'
  },
  columns: {
    type: 'Type',
    offer: 'Offer',
    status: 'Status',
    publishedAt: 'Published on',
    provider: 'Provider',
    providerType: 'Provider type',
    organization: 'Organization',
    bookings: 'Bookings',
    bookingRequests: 'Requests',
    actions: 'Actions'
  },
  offerType: {
    room: 'Room',
    material: 'Item'
  },
  offerStatus: {
    published: 'Published',
    draft: 'Draft',
    suspended: 'Suspended',
    reviewRequested: 'Review requested',
    removed: 'Removed'
  },
  providerType: {
    private: 'Private',
    business: 'Business'
  },
  actions: {
    label: 'Actions',
    lock: 'Lock offer',
    unlock: 'Unlock offer',
    remove: 'Remove offer'
  },
  lockConfirmation: {
    title: 'Lock offer?',
    content:
      'Do you want to temporarily suspend the offer “{{name}}”? It will be hidden publicly and new bookings will be blocked.',
    reasonLabel: 'Suspension reason (required)',
    reasonPlaceholder: 'Reason for suspension',
    messageLabel: 'Message to provider (optional)',
    messagePlaceholder: 'Optional message',
    confirm: 'Lock offer',
    cancel: 'Cancel'
  },
  unlockConfirmation: {
    title: 'Unlock offer?',
    content:
      'Do you want to lift the suspension for the offer “{{name}}”? The published state remains unchanged.',
    confirm: 'Unlock offer',
    cancel: 'Cancel'
  },
  removeConfirmation: {
    title: 'Permanently remove offer?',
    content:
      'Do you want to permanently remove the offer “{{name}}”? This action cannot be undone. Open requests and future bookings will be cancelled. Past bookings remain unchanged.',
    reasonLabel: 'Removal reason (required)',
    reasonPlaceholder: 'Reason for removal',
    messageLabel: 'Message to provider (optional)',
    messagePlaceholder: 'Optional message',
    confirm: 'Remove offer',
    cancel: 'Cancel'
  },
  empty: {
    top: 'No offers found',
    bottom: 'Adjust your search or try again later.'
  }
};
